/** @module SiteAdmin/PDFRequestStatusRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String"
], function(declare, StringRen) {

	return declare(StringRen, {
		/**
		 * @override
		 * Redraw row when updated
		 */
		onMonitor: function(amc, newValue) {
			amc.ctx.view.redrawNode(amc.refNode);
			return true;
		},

		/**
		 * @override
		 * Monitor changes to status if pending or active
		 */
		toHtmlStatic: function(ctx, h, refNode, params) {
			const value = this._getValue(ctx, h);

			if (value === "Pending" ||
				value === "Active" ||
				value === "Awaiting Sub-Requests") {
				this.monitor(ctx, h, refNode, value);
			}

			return this.inherited(arguments);
		}
	});
});